uniform sampler2D tDiffuse;
varying vec2 vUv;

float luminance( const in vec3 rgb ) {
	// assumes rgb is in linear color space with sRGB primaries and D65 white point
	const vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );
	return dot( weights, rgb );
}

void main() {
	vec4 texel = texture2D( tDiffuse, vUv );
	float l = luminance( texel.rgb );
	gl_FragColor = vec4( l, l, l, texel.w );
}